module.exports = __webpack_public_path__ + "static/img/f195ae53e16e70c04efb868efe043664.6c342fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/f195ae53e16e70c04efb868efe043664.jpg
// module id = oU9F
// module chunks = 20